const DEFAULT_LOCALE = 'eng';

const LOCALES_LIST = [
	{
		code: 'eng',
		file: 'eng.js',
	},
	{
		code: 'est',
		file: 'est.js',
	},
	{
		code: 'fin',
		file: 'fin.js',
	},
	{
		code: 'lat',
		file: 'lat.js',
	},
	{
		code: 'lit',
		file: 'lit.js',
	},
	{
		code: 'rus',
		file: 'rus.js',
	},
	{
		code: 'spa',
		file: 'spa.js',
	},
	{
		code: 'ger',
		file: 'ger.js',
	},
	{
		code: 'fre',
		file: 'fre.js',
	},
];

export default {
	LOCALES_LIST,
	DEFAULT_LOCALE,
};
